import React from "react";
import { useTranslation } from "react-i18next";
import { DialogFrame, useDialog } from "./dialog-base";
import IconButton from "../LogoButton/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

interface ApprovalConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onApprove: () => void;
  logoTitle: string;
}

export const ApprovalConfirmationDialog: React.FC<
  ApprovalConfirmationDialogProps
> = ({ open, onClose, onApprove, logoTitle }) => {
  const { t } = useTranslation();
  const dialogOption = {
    isOpen: open,
    openDialog: () => {},
    closeDialog: onClose,
  };

  return (
    <DialogFrame dialogOption={dialogOption} onClose={onClose}>
      <div className="p-6 space-y-4">
        <h2 className="text-lg font-semibold">
          {t("compDialogsInput.approvalRequired")}
        </h2>
        <div className="space-y-4">
          <p className="text-sm">
            {t("compDialogsInput.approveBeforePreview", { title: logoTitle })}
          </p>
          <p className="text-sm">
            {t("compDialogsInput.approveNowQuestion")}
          </p>
        </div>
        <div className="flex gap-2 justify-between">
          <IconButton
            variant="dim"
            onClick={onClose}
            icon={<FontAwesomeIcon icon={faXmark} />}
          >
            {t("cancel")}
          </IconButton>
          <IconButton
            variant="success"
            onClick={onApprove}
            icon={<FontAwesomeIcon icon={faCheck} />}
          >
            {t("compDialogsInput.approve")}
          </IconButton>
        </div>
      </div>
    </DialogFrame>
  );
};
